
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp-frontend-contact-completed",
      function () {
        return require("private-next-pages/lp-frontend-contact-completed.tsx");
      }
    ]);
  